import { render } from "./MonsterSlayer.vue?vue&type=template&id=0ba05fe8&scoped=true"
import script from "./MonsterSlayer.vue?vue&type=script&lang=js"
export * from "./MonsterSlayer.vue?vue&type=script&lang=js"

import "./MonsterSlayer.vue?vue&type=style&index=0&id=0ba05fe8&scoped=true&lang=css"

import exportComponent from "/Users/josecisneros/Desktop/Jose-Cisneros/Portfolio-Site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba05fe8"]])

export default __exports__